import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmptyStateVoicemail = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 559.7 493.26",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".c{fill:#ebf3ff;}.d{fill:#fafcff;}.e{fill:#9ec5ff;}.f{fill:#dcebfe;}.g{opacity:.15;}" }) }),
		/* @__PURE__ */ _jsx("g", {
			id: "a",
			children: /* @__PURE__ */ _jsx("circle", {
				className: "d",
				cx: 246.8,
				cy: 246.79,
				r: 246.8
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "b",
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "f",
					d: "M383.11,347.1c-.08-.28-.17-.56-.28-.82,19.72-27.54,31.33-61.27,31.33-97.73,0-92.8-75.23-168.02-168.02-168.02S78.12,155.75,78.12,248.55s75.23,168.02,168.02,168.02c36.22,0,69.76-11.46,97.2-30.95l43.44,25.61c5.85,3.45,12.94-1.93,11.18-8.49l-14.86-55.64Z"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "e",
					d: "M306.54,205.61c-26.15,0-47.34,21.19-47.34,47.34,0,8.79,2.48,16.91,6.54,23.89h-37.87c4.06-6.99,6.54-15.1,6.54-23.89,0-26.15-21.19-47.34-47.34-47.34s-47.34,21.19-47.34,47.34,21.19,47.34,47.34,47.34h119.48c26.15,0,47.34-21.19,47.34-47.34s-21.19-47.34-47.34-47.34h0Zm-143.37,47.34c0-13.07,10.82-23.89,23.89-23.89s23.9,10.82,23.9,23.89-10.82,23.89-23.89,23.89-23.9-10.82-23.9-23.89Zm143.37,23.89c-13.07,0-23.89-10.82-23.89-23.89s10.82-23.89,23.89-23.89,23.89,10.82,23.89,23.89c0,13.07-10.59,23.89-23.89,23.89h0Z"
				}),
				/* @__PURE__ */ _jsxs("g", { children: [
					/* @__PURE__ */ _jsx("circle", {
						className: "g",
						cx: 387.6,
						cy: 142.24,
						r: 51.18
					}),
					/* @__PURE__ */ _jsx("circle", {
						className: "e",
						cx: 390.73,
						cy: 137.93,
						r: 51.18
					}),
					/* @__PURE__ */ _jsx("path", {
						className: "c",
						d: "M414.88,123.62c.05,1.12-.37,2.22-1.16,3.01l-28.09,28.09c-.71,.71-1.62,1.21-2.62,1.29-1.19,.1-2.33-.32-3.16-1.15l-12.1-12.1c-.79-.79-1.22-1.89-1.16-3.01,.05-1.12,.58-2.17,1.45-2.89,1.56-1.29,3.96-1.14,5.45,.35l9.12,9.12s.1,.04,.14,0l25.25-25.25c1.49-1.49,3.88-1.64,5.45-.35,.87,.72,1.39,1.77,1.45,2.9Z"
					})
				] })
			]
		})
	]
});
export default SvgEmptyStateVoicemail;
